import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './transparencia.css';
import { transparencia_item } from '../../json/transparenciaItem';
import { archivo_item } from '../../json/archivoItem';

const Transparencia = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
            <div className='col-12'>
                <div className='transparencia_title'>
                    <h1>Transparencia</h1>
                    <hr class="hr-gob"/>
                </div>
            </div>
        </div>
        <div className='row'>
           
            {
                transparencia_item.map((item, index)=>(
                    <div key={ index } className='col-md-4'>                        
                        <Link to={ item.transparencia_item_url } style={{textDecoration: 'none'}}>
                            <div className='card'>
                                <div class="card-body">
                                    <div class='sec_transparencia transparencia_item'>
                                        <h5> { item.transparencia_item_nombre }</h5>                                
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))
            }
            
        </div>

        <div className='row'>
            <div className='col-12'>
                <div className='archivo_title'>
                <hr class="hr-gob"/>
                    <h1>Programa Anual de Desarrollo Archivistico</h1>
                    <hr class="hr-gob"/>
                </div>
            </div>
        </div>
        <div className='row'>
            {
                archivo_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 archivo_item'>
                        <Link to={ item.archivo_item_url }>{ item.archivo_item_nombre }</Link>
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Transparencia